import {
    Grid,
    Card,
    CardContent,
    CardMedia,
    Typography,
    CircularProgress,
    Alert,
    Button,
    Box,
    Dialog,
    DialogContent,
    DialogTitle,
    Chip,
    useMediaQuery,
    IconButton,
    
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useState, useEffect } from "react";
import { apiUrl, backendHosts } from "../../../../ui-utils/apiConfig";
import axios from "axios";
import { Help } from "@mui/icons-material";
import ResearchForm from "./ResearchForm";
import ResearchCreateForm from "./ResearchCreateForm";
import CloseIcon from "@mui/icons-material/Close";
export default function Research() {
    const [research, setResearch] = useState([])
    const [categories, setCategories] = useState([])
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedTags, setSelectedTags] = useState([]);
    const isSmallScreen = useMediaQuery("(max-width:900px)");
    const isMediumScreen = useMediaQuery("(max-width:1200px)");
    const [openModal, setOpenModal] = useState(false);
    const [selectedResearch, setSelectedResearch] = useState(null);
    const [createModal,setCreateModal]=useState(false)
    const handleResearchClick = (data) => {
        setSelectedResearch(data);
        console.log("dataaaa",data)
        setOpenModal(true);
    };

    const [filterData,setFilterData]=useState([])

    const handleCloseModal = () => {
        setOpenModal(false);
        setSelectedResearch(null);
    };

    const handleCloseCreateModal = () => {
        setCreateModal(false);
    };

    const fetchResearch = async () => {
        try {
            const response = await axios.get(`${backendHosts.ADMIN}${apiUrl.getAllResearch}`)
            const result = response?.data?.data?.data
            return result
        } catch (error) {
            throw new Error(error.message);
        }
    };

    const fetchCategories = async () => {
        try {
            const response = await axios.get(`${backendHosts.ADMIN}${apiUrl.getCategory}`)
            const result = response.data.data.data
            return result
        } catch (error) {
            console.log("Research error", error)
        }
    };

    const loadData = async () => {
        try {
            setSelectedTags([])
            const ResearchData = await fetchResearch();
            const categoriesData = await fetchCategories();
            console.log("dataa", ResearchData, categoriesData)
            setResearch(ResearchData);
            setFilterData(ResearchData);
            setCategories(categoriesData);
        } catch (error) {
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadData()
    }, [])


    const handleTagClick = (tagName) => {
        console.log("Clicked Tag:", tagName);

        setSelectedTags((prevTags) => {
            let updatedTags;

            if (prevTags.includes(tagName)) {
                // If already selected, remove the tag
                updatedTags = prevTags.filter((tag) => tag !== tagName);
            } else {
                // Otherwise, add the new tag
                updatedTags = [...prevTags, tagName];
            }

            // If no tags are selected, show all data
            if (updatedTags.length === 0) {
                setFilterData(research);
                return updatedTags;
            }

            // Filter data based on selected tags
            const filteredData = research.filter((item) =>
                updatedTags.includes(item.category?.category_name)
            );

            setFilterData(filteredData);
            return updatedTags;
        });
    };


    const handleTitleClick=(link)=>{
        console.log("hello", link)
        if (link) {
            window.open(link, "_blank", "noopener,noreferrer");
        } else {
            console.warn("No link available for this research item.");
        }
    }
    console.log("categories", categories)

    return (
        <>
        {/* <ResearchForm categories={categories}/> */}
            <Box sx={{ p: 4, mt: 5, height: "100vh", width: "100vw" }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", mb: 3 }}>
                    <Typography variant="h4" fontWeight="bold" sx={{ color: "white" }}>
                        Research
                    </Typography>

                    <Box sx={{ display: "flex", gap: 2 }}>
                        <Button
                            variant="contained"
                            startIcon={<AddIcon />}
                            sx={{
                                backgroundColor: "#E93333",      // Default background
                                color: "white",                  // Ensure text stays white
                                "&:hover": {
                                    backgroundColor: "#E93333",    // Same color on hover
                                },
                                "&:focus": {
                                    backgroundColor: "#E93333",    // Same color on focus
                                },
                                "&:active": {
                                    backgroundColor: "#E93333",    // Same color when clicked
                                },
                                textTransform: "none",
                                boxShadow: "none",
                            }}

                            onClick={()=>{setCreateModal(true)}}
                        >
                            Create
                        </Button>
            
                    </Box>
                </Box>



                {loading && (
                    <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
                        <CircularProgress />
                    </Box>
                )}

                <Box sx={{ mb: 3, color: "white" }}>
                    <Typography variant="subtitle1" sx={{ mb: 1 }}>
                        Tags ({research?.length} total)
                    </Typography>

                    
                    {categories.map((tag) => (
                        <Chip
                            key={tag.category_name}
                            label={`${tag.category_name} (${tag.research_count || 0})`}
                            onClick={() => handleTagClick(tag.category_name)}
                            sx={{
                                borderRadius: "20px",
                                mb: 1,
                                mr:1,
                                bgcolor: selectedTags.includes(tag.category_name) ? "white" : "gray",
                                color: selectedTags.includes(tag.category_name) ? "black" : "white",
                                "&:hover": {
                                    bgcolor: selectedTags.includes(tag.category_name)
                                        ? "#f0f0f0"
                                        : "#333",
                                    borderRadius: "20px",
                                },
                            }}
                        />
                    ))}
                </Box>


                <Grid container spacing={3}>
                    {filterData?.map((data) => {
                        const thumbnail = data?.thumbnail?.image_link

                        return (
                            <Grid item key={data.id} xs={12} sm={6} md={4}>
                               
                                <Card
                                    sx={{
                                        cursor: "pointer",
                                        transition: "transform 0.3s, box-shadow 0.3s",
                                        "&:hover": {
                                            transform: "scale(1.05)",
                                            boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
                                        },
                                        borderRadius: "12px",
                                        border: "1px solid #e0e0e0",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "flex-start",
                                        alignItems: "stretch", // Make children fill the card width
                                        overflow: "hidden", // Prevent overflow
                                        height: () => {
                                            if (isSmallScreen) return "415px";
                                            if (isMediumScreen) return "360px";
                                            return "400px";
                                        },
                                    }}
                                    onClick={() => handleResearchClick(data)}
                                >
                                    {/* Image Wrapper */}
                                    <Box
                                        sx={{
                                            width: "100%",
                                            height: 250, // Fixed height for image section
                                            overflow: "hidden",
                                            borderTopLeftRadius: "12px",
                                            borderTopRightRadius: "12px",
                                            flexShrink: 0, // Prevent the image from shrinking
                                        }}
                                    >
                                        <CardMedia
                                            component="img"
                                            image={thumbnail}
                                            alt={data?.title}
                                            sx={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "cover", // Fill the container, cropping if necessary
                                                display: "block",
                                            }}
                                        />
                                    </Box>

                                    {/* Content Section */}
                                    <CardContent
                                        sx={{
                                            flexGrow: 1,
                                            padding: "16px",
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "space-between",
                                        }}
                                    >
                                        <Box>
                                            <Typography variant="h6" fontWeight="bold" gutterBottom
                                             noWrap
                                                sx={{
                                                    cursor: "pointer",
                                                    color: "#000000",
                                                    transition: "color 0.2s, text-decoration 0.2s",
                                                    "&:hover": {
                                                        textDecoration: "underline", // Underline on hover
                                                    },
                                                }}
                                                onClick={() => handleTitleClick(data?.pdf_link)}
                                             >
                                                {data?.title?.substring(0, 100)}...
                                            </Typography>

                                            <Typography
                                                sx={{
                                                    color: "#999999",
                                                    marginBottom: "15px",
                                                    fontSize: "14px",
                                                }}
                                            >
                                                {data.description?.substring(0, 100)}...
                                            </Typography>

                                            {/* Category Chip */}
                                            {data.category?.category_name && (
                                                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}>
                                                    <Chip label={data.category.category_name} size="small" />
                                                </Box>
                                            )}
                                        </Box>

                                        {/* Footer Section */}
                                        <Box
                                            sx={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                mt: 2,
                                            }}
                                        >
                                            <Typography variant="caption" color="text.secondary">
                                                {new Date(data.created_at).toLocaleDateString("en-US", {
                                                    year: "numeric",
                                                    month: "long",
                                                    day: "numeric",
                                                })}
                                            </Typography>
                                        </Box>
                                    </CardContent>
                                </Card>

                            </Grid>
                        );
                    })}
                </Grid>

                <Dialog open={openModal} onClose={handleCloseModal} maxWidth="sm" fullWidth>
                    <DialogContent sx={{ position: "relative", paddingTop: "40px" }}>
                        <IconButton
                            aria-label="close"
                            onClick={handleCloseModal}
                            sx={{
                                position: "absolute",
                                right: 8,
                                top: 8,
                                color:"#E93333"
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                        <ResearchForm
                            selectedResearch={selectedResearch}
                            categories={categories}
                            handleCloseModal={handleCloseModal}
                            loadData={loadData}
                        />
                    </DialogContent>
                </Dialog>


                <Dialog open={createModal} onClose={handleCloseCreateModal} maxWidth="sm" fullWidth>
                    <DialogContent sx={{ position: "relative", paddingTop: "40px" }}>
                        {/* Close Icon Inside DialogContent */}
                        <IconButton
                            aria-label="close"
                            onClick={handleCloseCreateModal}
                            sx={{
                                position: "absolute",
                                right: 8,
                                top: 8,
                                color: "#E93333"
                            }}
                        >
                            <CloseIcon />
                        </IconButton>

                        {/* Your Form Component */}
                        <ResearchCreateForm
                            categories={categories}
                            handleCloseCreateModal={handleCloseCreateModal}
                            loadData={loadData}
                           
                        />
                    </DialogContent>
                </Dialog>

            </Box>
        </>
    )
}